import { render, staticRenderFns } from "./msgManage.vue?vue&type=template&id=54bb5ee0&scoped=true"
import script from "./msgManage.vue?vue&type=script&lang=js"
export * from "./msgManage.vue?vue&type=script&lang=js"
import style0 from "./msgManage.vue?vue&type=style&index=0&id=54bb5ee0&prod&lang=less&scoped=true"
import style1 from "./msgManage.vue?vue&type=style&index=1&id=54bb5ee0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bb5ee0",
  null
  
)

export default component.exports